import { success } from '../../../../web/styles/colors';
import { ctaButtonProps } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		height: '100%',
	},
	publishButton: {
		...ctaButtonProps(success, success, success),
		height: 40,
	},
});
